import React from 'react';
import useReadbookTask from '../../hooks/useReadbookTask';
import {CircularProgress, Stack, Typography} from '@mui/material';

const ReadbookTask = () => {
    const {task, loading, error} = useReadbookTask();

    if (loading) return <Stack p={2} alignItems="center"><CircularProgress size={20}/></Stack>;
    if (error) return <Stack p={2}><Typography
        color="error">{error.message || 'Failed to load task'}</Typography></Stack>;
    if (!task) return <Stack p={2}><Typography>No task found for this readbook.</Typography></Stack>;

    return (
        <Stack p={1} border={'1px solid'} borderColor={'divider'} borderRadius={1}>
            <Typography variant="subtitle2">Task status</Typography>
            <Typography variant="body1">{task.status || 'unknown'}</Typography>
        </Stack>
    );
};

export default ReadbookTask;